<template>
  <div class="modal-window large active">
    <TheLoader :small="true" :active="loading || updating" :update="updating"/>

    <div class="modal-window-header gray">
      <div class="modal-window-heading">
        <h3 class="icon-heading">
          <span class="icon"><svg width="28px" height="28px" viewBox="0 0 28 28"><use xlink:href="/static/sprites.svg#glyph-medium-artist"></use></svg></span>
          <span class="icon-heading-title">
            <span class="title">{{this.kunstner.Navn}}</span>
            <span class="subtitle">{{this.total}} {{this.total === 1 ? 'objekt' : 'objekter'}}</span>
          </span>
        </h3>
      </div>
    </div>

    <div v-if="!(loading || updating) && items.length < 1" class="modal-window-body no-padding custom-scrollbar">
      <div class="center-container">
        <div class="center-content">
          <div class="placeholder-icon"><svg width="44px" height="44px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-object"></use></svg></div>
          <h2 class="bold">Ingen objekter</h2>
          <p>Denne kunsteren har ingen objekter registrert på seg</p>
          <span class="loading-spinner"></span>
        </div>
      </div>
    </div>

    <overlay-scrollbars v-if="items.length > 0" id="result-content" :options="{ className: 'modal-window-body no-padding custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
      <table  class="large fixed visible" :class="{'clickable': items.length > 0}">
        <thead>
          <tr>
            <th>Objekt</th>
            <th class="show-for-medium">Tittel</th>
            <th class="show-for-large align-right">Minstepris</th>
            <th class="show-for-medium align-right">Vurdering</th>
            <th class="show-for-medium align-right">Tilslag</th>
            <th class="align-right">Ansvarlig</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" v-bind:key="item.Objektid" @click="showObjektItem(item)">
            <td>
              <div class="flex-container">
                <span class="thumbnail-container">
                  <span class="thumbnail small placeholder animation">
                    <template v-if="objektThumb(item) && objektLarge(item)">
                      <img class="hi-trigger" :src="objektThumb(item)" :data-hi-src-full="objektLarge(item)" data-hi-size="large" />
                    </template>
                    <template v-else-if="objektThumb(item)">
                      <img :src="objektThumb(item)" />
                    </template>
                    <template v-else>
                      <span class="placeholder"></span>
                    </template>
                  </span>
                  <a href="javascript:;" class="primary-title">{{item.Objektnr}}</a>
                </span>
              </div>
            </td>
            <td class="show-for-medium">
              {{item.title | truncate(40)}}
              <span class="opacity-60" v-if="item.subtitle"><br>{{item.subtitle | truncate(30)}}</span>
            </td>
            <td class="show-for-large align-right">
              <span class="opacity-60" v-if="item.Minstepris">{{item.Minstepris | thousands}}</span>
              <span class="opacity-60" v-else>-</span>
            </td>
            <td class="show-for-medium align-right">
              <span class="opacity-60" v-if="item.Vurderingspris1>0 && item.Vurderingspris2>0">
                {{item.Vurderingspris2 | thousands}} - {{item.Vurderingspris1 | thousands}}
              </span>
              <span v-else>
                <span class="opacity-60" v-if="item.Vurderingspris1>0">
                  {{item.Vurderingspris1 | thousands}}
                </span>
                <span class="opacity-60" v-if="item.Vurderingspris2>0">
                  {{item.Vurderingspris2 | thousands}}
                </span>
              </span>
            </td>
            <td class="show-for-medium align-right">
              {{showTilslag(item)}}
            </td>
            <td class="align-right">
              <span v-if="item.kontraktsansvarlig" class="avatar name left" :class="strToAvatarClass(item.kontraktsansvarlig.initials)">{{item.kontraktsansvarlig.initials}} <span class="name">{{item.kontraktsansvarlig.full_name}}</span></span>
              <span v-else class="avatar name left" :class="strToAvatarClass('-')">- <span class="name">Ingen ansvarlig</span></span>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="pagination-container" v-show="pages > 1">
        <paginate
          v-model="page"
          :page-count="pages"
          :page-range="11"
          :click-handler="changePage"
          :container-class="'pagination'"
          :prev-text="paginationArrow"
          :next-text="paginationArrow"
          :prev-class="'prev'"
          :next-class="'next'"
          >
        </paginate>
      </div>
    </overlay-scrollbars>

    <a href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
      <span>Lukk</span>
      <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
    </a>
  </div>
</template>

<script>
import SearchService from '@/services/SearchService'
import accounting from 'accounting-js'

export default {
  name: 'KunstnerObjektListModal',
  props: {
    kunstner: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      updating: false,
      page: 1,
      pages: 1,
      total: 0,
      items: []
    }
  },
  created () {
    this.load()
  },
  methods: {
    changePage: function (page) {
      var vm = this

      window.jQuery('.os-viewport', window.jQuery('#result-content')).animate({
        scrollTop: 0
      }, 200, function () {
        // Update a copy of the query params, to send to our store
        vm.updating = true
        vm.load()
      })
    },
    load: function () {
      SearchService.objekt({ Kunstnerid: this.kunstner.Idnr }, this.page)
        .then((response) => {
          this.pages = response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1
          this.total = response.headers['x-paging-count'] ? parseInt(response.headers['x-paging-count']) : 0
          this.items = response.data
        })
        .catch((error) => {
          console.log(error)
        })
        .then(() => {
          this.loading = false
          this.updating = false
        })
    },
    objektThumb: function (item) {
      if (item.photos && item.photos.thumb && item.photos.thumb.length > 0) {
        return item.photos.thumb[0]
      }

      return null
    },
    objektLarge: function (item) {
      if (item.photos && item.photos.large && item.photos.large.length > 0) {
        return item.photos.large[0]
      }

      return null
    },
    showTilslag: function (item) {
      if (this._.startsWith(item.Auksjon, 'AR')) {
        return 'Usolgt'
      }

      return item.Salgspris ? accounting.formatNumber(item.Salgspris, { precision: 0, thousand: ' ' }) : 0
    },
    showObjektItem: function (item) {
      let url = '/kunde/' + item.kontrakt.Kundenr + '?kontrakt=' + item.Kontraktnr + '&objekt=' + item.Objektid
      let win = window.open(url, '_blank')

      window.jQuery('#hi-container').removeClass('active')
      window.jQuery(document).unbind('mousemove')

      if (win) {
        win.focus()
      } else {
        this.$helpers.showSuccessAlert(
          'Du må tillate pop up vinduer',
          '<a href="' + url + '" target="_blank">Gå til objekt...</a>',
          true,
          10000
        )
      }
    },
    closeButtonClick: function () {
      window.jQuery('#hi-container').removeClass('active')
      window.jQuery(document).unbind('mousemove')

      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KunstnerObjektListModal.vue